import { useEffect, useState } from "react";
import HookForm from "../../../components/HookForm/HookForm";
import getContainerCard from "../../../api/containers/getContainerCard";
import { useParams } from "react-router-dom";
import alert from "../../../helpers/alert";
import SelectMarks from "../../../components/Selects/SelectMarks";
import SelectModels from "../../../components/Selects/SelectModels";
import DocsInputNew from "../../../components/Inputs/DocsInput/DocsInputNew";
import editContainer from "../../../api/containers/editContainer";
import Header from "../../../components/Header/Header";
import formatNumber from "../../../utils/formatNumber";
import ContainerColorPhotos from "./ContainerColorPhotos";

// Выгружать ли модель на Халык Маркет. Признак машины (forApp) общий для
// каталога приложения и витрины площадки, поэтому выключатель отдельный:
// Халык просил присылать только часть моделей, а в приложении нужны все.
const HalykMarketField = ({ value, label, onChange }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
    <input
      type="checkbox"
      id="halykMarket"
      checked={!!value}
      onChange={(e) => onChange(e.target.checked)}
    />
    <label htmlFor="halykMarket">{label}</label>
  </div>
);
const formStyles = {
    carInfo: { display: 'grid', gap: '20px', gridTemplateColumns: `1fr 1fr 1fr 1fr` },
    dealerInfo: { display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr' },
    other: { display: 'grid', gap: '20px' },
  };
  
const CarContainerEdit = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([]);
    // Форма читает значения полей один раз, при монтировании, а карточка
    // приходит с сервера позже. Без этого счётчика галочка «Выгружать на
    // Halyk Market» всегда показывалась пустой — и сохранение выключало
    // выгрузку, даже если в карточке она была включена.
    const [formVersion, setFormVersion] = useState(0);

      const save = async (values) => {
        setLoading(true)
        try {
            await editContainer({
                containerId: id,
                photo: values?.photo,
                customPrice: values?.customPrice,
                halykMarket: values?.halykMarket
            });
            alert.success("Изменения успешно сохранены")
            update();
        } catch(e) {
            alert.error(e)
        } finally {
            setLoading(false)
        }
      }

      const update = async () => {
        setLoading(true)
        try {
            const res = await getContainerCard({ id });
            const container = res?.data?.container;

            setData([
                {
                    name: 'mark',
                    component: SelectMarks,
                    label: 'Марка',
                    placeholder: 'Выберите из списка',
                    defaultValue: { value: container?.mark?.id, label: container?.mark?.name },
                    disabled: true,
                  },
                  {
                    name: 'model',
                    component: SelectModels,
                    dependency: 'mark',
                    dependencyAccessor: (obj) => obj?.value,
                    label: 'Модель',
                    placeholder: 'Выберите из списка',
                    defaultValue: { value: container?.model?.id, label: container?.model?.name },
                    disabled: true,
                  },
                  {
                    name: 'customPrice',
                    label: 'Цена от',
                    placeholder: 'Укажите минимальную цену',
                    format: 'number',
                    defaultValue: formatNumber(container?.customPrice),
                  },
                  {
                    name: 'halykMarket',
                    label: 'Выгружать на Halyk Market',
                    component: HalykMarketField,
                    defaultValue: container?.halykMarket !== false,
                  },
                  {
                    name: 'photo',
                    component: DocsInputNew,
                    label: 'Фото',
                    text: 'Фото',
                    id: Math.random(),
                    showImage: true,
                    imageUrl: container?.url,
                  }
            ])
            setFormVersion((prev) => prev + 1);
        } catch(e) {
            alert.error(e);
        } finally {
            setLoading(false)
        }
      }

      useEffect(() => {
        update();
      }, [])

    return(<>
        <Header title="Редактировать марку и модель" />
        <HookForm key={formVersion} inputs={data} border grid={formStyles.carInfo} onSubmit={save} loading={loading} action="Сохранить изменения" />
        <ContainerColorPhotos containerId={id} />
    </>)
}

export default CarContainerEdit;